<template>
  <a-card :bordered='false'>
    <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="解除关系二维码" name='code'>
        <a-input class='width60 m-r-15' v-model:value="code" placeholder="请输入二维码" />
        <a-button type="primary" @click='codeConfirm'>确定</a-button>
        <div class="m-t-20" v-if='show'>
          <a-descriptions layout="vertical" bordered>
            <a-descriptions-item label="大标">{{code_result.code_base_info.big_code}}</a-descriptions-item>
            <a-descriptions-item label="中标">
              <p class="text-ac s_lin_h30" v-for="(item,index) in code_result.middle_code_data" :key='index'>{{item}}</p>
            </a-descriptions-item>
            <a-descriptions-item label="小标">
              <p class="text-ac s_lin_h30" v-for="(item,index) in code_result.small_code_data" :key='index'>{{item}}</p>
            </a-descriptions-item>
          </a-descriptions>
          <p>此操作不可逆，请谨慎！确定需要解除关系吗？</p>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 2, offset: 3 }">
        <a-button type="primary" block v-has:antiCodeRelieve="onSubmit" :disabled="!code">解除关系</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { ref, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { setDissolve,dissolveConfirm} from '@/api/antiFleeing';
export default {
  setup() {
    const state = reactive({
      labelCol: {span: 3},
      wrapperCol: {span: 12},
      code:'',
      code_result:{}, //码信息
      show:false //是否显示码信息
    });
    //确定按钮
    const codeConfirm = async () => {
      if (!state.code) {
        return message.error("请输入二维码");
      }
      const hide = message.loading("正在加载中...", 0);
      let res = await dissolveConfirm({code_sn:state.code}).then(res => res.data).catch(error => error);
      if (iscode(res)) {
        state.code_result = res.data;
        state.show = true
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    }
    //解除关系
    const onSubmit = async () => {
      if (!state.code) {
        return message.error("请输入二维码");
      }
      const hide = message.loading("正在加载中...", 0);
      let res = await setDissolve({code_sn:state.code}).then(res => res.data).catch(error => error);
      if (iscode(res)) {
        message.success(res.msg);
        state.show = false;
        state.code = '';
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    }
    return {
      ...toRefs(state),
        onSubmit,
        codeConfirm
    };
  },
};
</script>
